/**
 * 缓存说明:电费账单缓存
 */
import vm from '@/cache/storeTools.js'
import unitApi from '@/components/api/unitApi.js'
import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'

var basestate = {
	// 当前公司信息
	nowUnit: {},
	columns: [
				{
					name: '业主姓名',
					key: 'ownerName',
					type: 'slot'
				},{
					name: '结算周期',
					key: 'time'
				},{
					name: '充值金额(元)',
					key: 'add',
					type: 'slot'
				},{
					name: '退费金额(元)',
					key: 'refund',
					type: 'slot'
				},{
					name: '账户余额(元)',
					key: 'balance',
					type: 'slot'
				},
			],
	chargingStatusList: [{text:'全部'},{text:'未缴费',value:0},{text:'已缴费',value:1},{text:'无效',value:-1},{text:'超时',value: -2}],
	meterList: [], // 抄表设备列表
	unitDeductionFeeDay: null, // 单位抄表日期
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setNowUnit(state, unit) {
			if(unit == undefined || isempty(unit)){
				return
			}
			vm.Vue.set(state, 'nowUnit', unit)
			store.commit('getMeterReadingConfigList', unit.id)
			//store.commit('getUnitDeductionFeeDay')
		},

		getMeterReadingConfigList(state, unitId){
			meterReadingApi.getMeterReadingConfigListByUnitId(unitId, respon => {
				vm.Vue.set(state, 'meterList', respon)
			})
		},
	}
});

//对外提供
export default store